exports.components = {
  "component---src-pages-az-404-jsx": () => import("./../../../src/pages-az/404.jsx" /* webpackChunkName: "component---src-pages-az-404-jsx" */),
  "component---src-pages-az-index-jsx": () => import("./../../../src/pages-az/index.jsx" /* webpackChunkName: "component---src-pages-az-index-jsx" */)
}

